import { useEffect, useRef, useState } from 'react';
import { useSelector,useDispatch } from "react-redux";
import { Group, Grid, Tooltip, ScrollArea, Modal, Button, Text, createStyles, ActionIcon, rem }  from '@mantine/core';
import { Eye, CircleX, EyeCheck, PencilPlus, Article   } from 'tabler-icons-react';
import PdfLabel from './helper/PdfLabel';
import { set_docstoconvert,read_doc_notaronly, clear_read_doc_notaronly, set_isadhocsign } from '../slice/mainslice';
import intl from 'react-intl-universal';

import { SignDocumentStatus } from './helper/SignDocumentStatus';
import UserSignDocInfo from './helper/UserSignDocInfo';

const useStyles = createStyles((theme) => ({
  showuserback: {
    backgroundColor: `#ffffff`,
    //marginBottom: `10px`,
    padding: `5px`,
  },
    showuserback1: {
    backgroundColor: `#f1f3f570`,
    marginBottom: `10px`,
    padding: `5px`,
  },
    placename: {
    paddingLeft: `65px`,
    marginTop: `-35px`,
    },
    nogap: {
      padding: 0,
    },
    nogaptop: {
      padding: 0,
      marginTop: `-10px`,
    },
    textsize: {
        fontSize: rem('12px'),
        [theme.fn.smallerThan('lg')]: {
          fontSize: rem('10px'),
        },
      },
}));





const ViewAllDoc = (props:any) => {
  const dispatch = useDispatch()
   const { classes } = useStyles();
  const initdocs = useSelector((state: any) => state.user.meetingdocs)
  const drnId = useSelector((state: any) => state.user.meetinginfo.drnId)
  const userhavetosigndocs = useSelector((state: any) => state.user.userhavetosigndocs)
  const [docinprogress, setDocinprogress] = useState({view: false, resourceId: "" });
  const [showscrollbar, setshowscrollbar] = useState(false);
  const [opened, setOpened] = useState(false);
  const [docconvert, setDocconvert] = useState("");

  const iniusersigndocs = useSelector((state: any) => state.user.userhavetosigndocs)
  const notarreaddoconly = useSelector((state: any) => state.user.readdocnotaronly)
  const inituser = useSelector((state: any) => state.user.meetinguser)

  const [openDocUsers, setOpenDocUsers] = useState<Record<string, boolean>>({});
  const [openReadDocUsers, setOpenReadDocUsers] = useState("");

  const [contrefheight, setcontrefheight] = useState(0);
  
  //console.log("openReadDocUsers:",openReadDocUsers)
  const contref = useRef<HTMLDivElement>(null);

  

useEffect(() => {
    

    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.target === contref.current) {
          const { height } = entry.contentRect;
          setcontrefheight(height);
         // console.log('Height changed:', height, 'px');
        }
      }
    });


    if (contref.current) {
      observer.observe(contref.current);
    }

    return () => {
      if (contref.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(contref.current);
      }
      
    };
    }, []);



 useEffect(() => {
  if (contrefheight > 420 ) {
    setshowscrollbar(true)
  }

}, [contrefheight]);


  const sendopendoc = (resourceId: string) => {
    const handledocpayload = {
      drnId: drnId,
      resourceId: resourceId,
      command: "opendoc"   
    };

   //dispatch(read_doc_notaronly(resourceId));
   localStorage.setItem("savedTab", "info");
   dispatch({ type: 'SIGNALR_SENDOPENDOC', payload: handledocpayload });
   dispatch(read_doc_notaronly(""));
   setOpenReadDocUsers(resourceId);
  }
  
  /**
   * Funktion um das  Dokument das zum Vorlesen ausgewählt warzu schließen.
   */
  const sendclosedoc = (resourceId: string) => {
    // Close Dokument
    const handledocpayload = {
      drnId: drnId,
      resourceId: resourceId,
      command: "closedoc"   
    }; 
   
   localStorage.setItem("savedTab", "info"); 
   dispatch({ type: 'SIGNALR_SENDOPENDOC', payload: handledocpayload });
   setOpenReadDocUsers("");
  }


/**
 * Updates the state of `docconvert` with the provided `resourceId` and sets `opened` to `true`.
 * Modal Handling
 *
 * @param {boolean} view - A boolean indicating whether the view is being shown or not.
 * @param {string} resourceId - The ID of the resource to be converted.
 * @return {void} This function does not return anything.
 */
const handleconvertDocinprogress = (view:boolean, resourceId:string) => {
  setDocconvert(resourceId);
  setOpened(true);
}


const handleClose = () => {
  setOpened(false);
};


const handleYesClick = () => {
  handlesetDocinprogress(true, docconvert)
  setDocconvert("");
   sendopendocforsign_shared(true, docconvert)
  handleClose();
};

const handleNoClick = () => {
  setDocconvert("");
  handleClose();
};

const toggleDocUsers = (resourceId: string) => {
  setOpenDocUsers((prev) => ({
    ...prev,
    [resourceId]: !prev[resourceId],
  }));
};

const isDocUsersOpen = (resourceId: string) =>
  Boolean(openDocUsers[resourceId]);

  /**
   * Handles the click event for the convert button.
   * Calls the `convertsinglepdf` function to convert a single PDF.
   * Updates the `docinprogress` state with the provided `view` and `resourceId` values.
   * Closes the modal.
   *
   * @return {void} This function does not return anything.
   */
const handleConvertClick = () => {
  convertsinglepdf();
  sendopendocforsign_shared(true, docconvert)
  handleClose();
}

/**
 * Converts a single PDF document.
 *
 * @return {void} This function does not return anything.
 */
const convertsinglepdf = () => {
   
  const storeArray = [{
    resourceId: docconvert,
    error: null
  }];


  const convertarray = {
    drnId: drnId,
    DocumentResourceIds: [docconvert],
    IsForced: true
  };

   dispatch(set_docstoconvert(storeArray))
   dispatch({ type: 'SIGNALR_REQUEST_CONVERTDOKS', payload: convertarray });

}


/**
 * Setzt den Status "alle User haben das Dokument unterschrieben""
 *
 * @param {any} drnId - DRN Meeting ID
 * @param {any} resourceId - Dokumenten ID
 * @param {boolean} isSignedByAll - Status
 */
  const docisfinished = (resourceId:any) => {
    // Sent have Read Sign
    const handledocisfinished  = {
      drnId: drnId,
      resourceId: resourceId,
      isSignedByAll: true   
  };

  dispatch({ type: 'SIGNALR_SETDOCUMENTISSIGNEDBYAll', payload: handledocisfinished  });
}

/**
 * Nimmt den Status "alle User haben das Dokument unterschrieben" zurück"
 *
 * @param {any} drnId - DRN Meeting ID
 * @param {any} resourceId - Dokumenten ID
 * @param {boolean} isSignedByAll - Status
 */
const docisnotfinished = (resourceId:any) => {
  // Sent have Read Sign
  const handledocisfinished  = {
    drnId: drnId,
    resourceId: resourceId,
    isSignedByAll: false   
};

dispatch({ type: 'SIGNALR_SETDOCUMENTISSIGNEDBYAll', payload: handledocisfinished  });
}

  /**
   * A function that handles setting the document in progress.
   *
   * @param {boolean} view - Ansichtsparameter
   * @param {string} resourceId - Dokumente ID
   * @return {void} 
   */
  const handlesetDocinprogress = (view:boolean, resourceId:string ) => {
    setDocinprogress({ ...docinprogress, view: view, resourceId: resourceId })
    setshowscrollbar(false)
  }


  /** Neu Funktion um den Unterschrift Protess direkt auszulösen DEMO Only*/

const sendopendocforsign_shared = (view:boolean, resourceId:string) => { 

      // Filtern des Arrays
      /*const gefilterteDokumente =  userhavetosigndocs.filter(
      (dokument: { resourceId: string; }) => dokument.resourceId === resourceId
      );*/

        const userIdList: string[] = inituser?.map(
        (u: { userId: string }) => u.userId
        ) ?? [];

    
      const sendopendocforsign_sharedpayload = {
      resourceId: resourceId,
      drnId: drnId,
      command: "opendoc",
      participantIdsToSign: userIdList,   
    };

    //console.log("sendopendocforsign_sharedpayload:",sendopendocforsign_sharedpayload );

    dispatch({ type: 'SIGNALR_SENDOPENDOCFORSIGNSHARED', payload: sendopendocforsign_sharedpayload });
    dispatch(set_isadhocsign())
  }


  const openreaddoc = (resourceId:string) => {
    // Set Read Doc Notar Only State
    sendclosedoc(resourceId);
    dispatch(read_doc_notaronly(resourceId));
    
  }

  const closereaddoc = () => {
    // Clear Read Doc Notar Only State
    dispatch(clear_read_doc_notaronly());
  }





  let initdocsdata = initdocs
  //console.log("initdocsdata:",initdocsdata)


//console.log(iniusersigndocs)
// eslint-disable-next-line array-callback-return
const rows = (initdocsdata  || []).map((item:any, index:any) => {


 
  
 let color
  if (item.isSignedByAll === true) {
    color = "green"
  } else {
    color = "gray"
  }

  let isDisabled = false
  let isDisabledShow = false
  if (openReadDocUsers === item.resourceId ){
    isDisabled = true
    isDisabledShow = false
  }
  if (notarreaddoconly === item.resourceId ){
    isDisabledShow = true
    isDisabled = false
  }


  if (docinprogress.view === false ){
    return (
    <div  key={`${item.resourceId}-${index}`} className={isDocUsersOpen(item.resourceId) ? classes.showuserback1 : classes.showuserback}>
    <Grid>
     <Grid.Col span={12} className={classes.nogap}>
             <Group  spacing={1} position="right">
                
             {item.isPDFA1b &&
             <Tooltip label={intl.get('VIEWALLDOCS_ADHOC_BUTTON_TT')} multiline={true}>
            <ActionIcon
                //disabled={isDisabledShow}
                size="xl"
                variant="transparent"
                onClick={() => sendopendocforsign_shared(true, item.resourceId)}
                >
                <PencilPlus size={26} strokeWidth={1} />
            </ActionIcon> 
            </Tooltip>
            }
            {!item.isPDFA1b &&
            <Tooltip label={intl.get('VIEWALLDOCS_ADHOC_BUTTON_TT')} multiline={true}>
            <ActionIcon
                //disabled={isDisabledShow}
                size="xl"
                variant="transparent"
                onClick={() => handleconvertDocinprogress(true, item.resourceId)}
                >
                <PencilPlus size={26} strokeWidth={1} />
            </ActionIcon> 
            </Tooltip>
            }
            
            <Tooltip label={intl.get('VIEWALLDOCS_VIEW_BUTTON_TT')} multiline={true}>
                  <span>   
              {(openReadDocUsers === "" || openReadDocUsers !== item.resourceId) && 
              <ActionIcon
                disabled={isDisabledShow}
                size="xl"
                variant="transparent"
                onClick={() => sendopendoc(item.resourceId)}
                >
                <Article size={26} strokeWidth={1} />
            </ActionIcon> 
              }
              {openReadDocUsers === item.resourceId &&
              <ActionIcon
                disabled={isDisabledShow}
                size="xl"
                variant="transparent"
                onClick={() => sendclosedoc(item.resourceId)}
                >
                <CircleX size={26} strokeWidth={1} color={'gray'}/>
            </ActionIcon> 
             
              }
              </span> 
          </Tooltip>

             <Tooltip label={intl.get('VIEWALLDOCS_CONTROLL_BUTTON_TT')} multiline={true}>
                  <span>
             {notarreaddoconly !== item.resourceId && 
             <ActionIcon
                disabled={isDisabled}
                size="xl"
                variant="transparent"
                onClick={() => openreaddoc(item.resourceId)}
                >
                <EyeCheck size={26} strokeWidth={1}/>
            </ActionIcon> 
             
              } 
            
             {notarreaddoconly !== "" && notarreaddoconly === item.resourceId &&
             <ActionIcon
                disabled={isDisabled}
                size="xl"
                variant="transparent"
                onClick={() => closereaddoc()}
                >
                <CircleX size={26} strokeWidth={1} color={'gray'}/>
            </ActionIcon> 
              }  

              </span>
            </Tooltip>
            </Group>
            
   </Grid.Col>


       <Grid.Col span={2} className={classes.nogaptop}>  
        <SignDocumentStatus resourceId={item.resourceId} />
      {/*       
       {item.isSignedByAll &&
        <FileCheck size={48} strokeWidth={1} color={color} />
       }
      {!item.isSigPrepared && !item.isSignedByAll &&
        <FileText size={48} strokeWidth={1} color={color} />
      }
      {item.isSigPrepared && !item.isSignedByAll &&
        <FileSpreadsheet size={48} strokeWidth={1} color="gray" /> 
      }
        */}

 
      </Grid.Col>
   <Grid.Col span={10} className={classes.nogaptop}> 
 
        <PdfLabel isPDFA1b={item.isPDFA1b} signatureCount={item.signatureCount} resourceId={item.resourceId} convert={true} viewcount={false}/>
         <div className={classes.textsize}>{item.name}</div>
       </Grid.Col>
          

 </Grid>


<div className={isDocUsersOpen(item.resourceId) ? classes.showuserback1 : classes.showuserback}>
    <UserSignDocInfo resourceId={item.resourceId} opened={isDocUsersOpen(item.resourceId)} onToggle={() => toggleDocUsers(item.resourceId)}/>
</div>
 <hr />
       
</div>

   );
  };



  

  });


  return (
    <>
    
    {!showscrollbar &&
      <>
      <div ref={contref}>
        {rows}
      </div>
      </>
      }
      {showscrollbar &&
      <>
      <ScrollArea h={420} type="hover" offsetScrollbars>
        {rows}
      </ScrollArea>
      </>
      }

<Modal
title=""
opened={opened}
onClose={handleClose}
closeOnClickOutside={false}
withCloseButton={false}
size="55%"
shadow="sm"
centered
>
  <Text>{intl.get('SIGDOC_MOD_KONVERTTEXT')}</Text>

  <hr />
  <Grid>
  <Grid.Col span={4}>
    <Button fullWidth color="green" onClick={handleYesClick}>{intl.get('SIGDOC_MOD_BUTYES')}</Button>
    </Grid.Col>
    <Grid.Col span={4}>
       <Button fullWidth color="teal" onClick={handleConvertClick}>{intl.get('SIGDOC_MOD_BUTKONV')}</Button>
    </Grid.Col>
    <Grid.Col span={4}>
    <Button fullWidth color="gray" variant="light" onClick={handleNoClick}>{intl.get('SIGDOC_MOD_BUTNO')}</Button>
    </Grid.Col>
  </Grid>
</Modal> 
     
   </>

   

    

  );
}

export default ViewAllDoc;